<div class="container-fluid" *ngIf="!summaryMode">
    <div class="row">
        <div class="col-9">
        <textarea class="form-control w-100" name="answer_{{name}}" rows="6"
                  placeholder="{{placeholder}}"
                  #answerValidation="ngModel"
                  minLength="{{min}}"
                  maxLength="{{max}}"
                  required
                  [(ngModel)]="value">
        </textarea>
        </div>
        <div class="col-3">
            <input type="button" class="btn btn-outline-success w-100" [disabled]="disabled" value="Submit"
                   (click)="onClick()">
        </div>
    </div>
    <div class="row" *ngIf="!answerValidation.errors != null">
        <div class="col-12">
            <div *ngIf="answerValidation.errors?.minlength">
                Answer must be at least {{min}} characters long.
            </div>
        </div>
    </div>
</div>
<div class="container-fluid" *ngIf="summaryMode">
    <div class="row">
        <div class="col-12 text-center" *ngIf="value != null">{{value}}</div>
        <div class="col-12 text-center text-danger" *ngIf="value == null"><b>No answer</b></div>
    </div>
</div>
